export function getISODateString(date: Date) {
  return date.toISOString();
}
